import { render, staticRenderFns } from "./CanceledServices.vue?vue&type=template&id=8f1dbf36&scoped=true&"
import script from "./CanceledServices.vue?vue&type=script&lang=js&"
export * from "./CanceledServices.vue?vue&type=script&lang=js&"
import style0 from "./CanceledServices.vue?vue&type=style&index=0&id=8f1dbf36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1dbf36",
  null
  
)

export default component.exports